import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';
import Select from 'react-select';

import axios from 'axios';

import routes from 'app/routes';
import statuses from 'data/statuses';
import policyStatuses from 'data/policy_statuses';
import ModalForm from 'components/Enterprise/Create/ModalForm';

export default function Filters({
  keyword,
  setKeyword,
  setStatus,
  setManager,
  setContractType,
}) {
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [managersOption, setManagerOptions] = useState(null);

  const [loading, setLoading] = useState(false);

  const sendReport = () => {
    setLoading(true);

    axios
      .get(routes.api.enterprises.report)
      .then((_resp) => {
        swal({
          title: '',
          text: 'Enterprises Report will be updated soon. Please, open Google Sheet and check the update in a couple of minutes.',
        });
        setLoading(false);
      });
  };

  const loadManagers = () => {
    policyStatuses.push({
      label: 'No-Policy',
      value: 'no-policy',
      code: 0,
    });

    axios.get(routes.api.team_leads.list).then((resp) => {
      setManagerOptions(
        resp.data.data
          .map((item) => ({ label: item.attributes.full_name, value: item.id }))
          .sort((a, b) => {
            const nameA = a.label.toUpperCase(); // ignore upper and lowercase
            const nameB = b.label.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }

            // names must be equal
            return 0;
          }),
      );
    });
  };

  useEffect(() => {
    loadManagers();
  }, []);

  return (
    <div className="invite_search">
      <Form className="" horizontal>
        <Row>
          <Col md={10}>
            <Row>
              <Col md={6}>
                <FormGroup controlId="status">
                  <Col componentClass={ControlLabel} sm={4}>
                    Account Manager
                  </Col>
                  <Col sm={8}>
                    <Select
                      isClearable
                      isSearchable
                      placeholder={
                        managersOption == null ? 'Loading ...' : 'Select'
                      }
                      onChange={(option) => {
                        setManager(option == null ? '' : option.value);
                      }}
                      options={managersOption}
                    />
                  </Col>
                </FormGroup>

                <FormGroup controlId="company_name">
                  <Col componentClass={ControlLabel} sm={4}>
                    Company Name
                  </Col>
                  <Col sm={8}>
                    <FormControl
                      type="text"
                      value={keyword}
                      onChange={(e) => setKeyword(e.target.value)}
                    />
                  </Col>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup controlId="status">
                  <Col componentClass={ControlLabel} sm={4}>
                    Status
                  </Col>
                  <Col sm={8}>
                    <Select
                      isClearable
                      onChange={(option) => {
                        setStatus(option == null ? '' : option.value);
                      }}
                      options={statuses}
                    />
                  </Col>
                </FormGroup>

                <FormGroup controlId="contract_type">
                  <Col componentClass={ControlLabel} sm={4}>
                    Contract Type
                  </Col>
                  <Col sm={8}>
                    <Select
                      isClearable
                      onChange={(option) => {
                        setContractType(option == null ? '' : option.value);
                      }}
                      options={policyStatuses}
                    />
                  </Col>
                </FormGroup>
              </Col>
            </Row>
          </Col>

          <Col md={2} className="text-right">
            <Row>
              <Col xs={12}>
                <Button
                  bsStyle="primary"
                  className="mb15"
                  onClick={() => setShowCreateForm(true)}
                >
                  Add Enterprise
                </Button>

                <ModalForm
                  showForm={showCreateForm}
                  closeForm={() => setShowCreateForm(false)}
                />
              </Col>
            </Row>

            <Row>
              <Col xs={12}>
                <Button
                  bsStyle="primary"
                  disabled={loading}
                  onClick={sendReport}
                >
                  Report
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </div>
  );
}
